
        module.exports = __webpack_public_path__ + "assets/images/logo-donorinfo.157ac834.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 360,
            height: 166,
            type: "png",
            bytes: 27315,

            toString: function() {
                return src;
            }
        };
    